import { render } from "./GeneralPropertiesCard.vue?vue&type=template&id=15172fd6"
import script from "./GeneralPropertiesCard.vue?vue&type=script&lang=js"
export * from "./GeneralPropertiesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__